import { H1, H2, H3, H4, H5, H6 } from '@components/text';
import type { PortableTextBlockComponent } from '@portabletext/react';
import type { PropsWithChildren } from 'react';
import type { RichTextBlockStyle } from 'types/components/rich-text/rich-text-style';

type RichTextStyleMap = {
  [key in RichTextBlockStyle]?: PortableTextBlockComponent;
};

export const RICH_TEXT_STYLE_COMPONENTS: RichTextStyleMap = {
  h1: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H1>{children}</H1>
    </div>
  ),
  h2: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H2>{children}</H2>
    </div>
  ),
  h3: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H3>{children}</H3>
    </div>
  ),
  h4: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H4>{children}</H4>
    </div>
  ),
  h5: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H5>{children}</H5>
    </div>
  ),
  h6: ({ children }: PropsWithChildren) => (
    <div style={{ marginTop: '2rem' }}>
      <H6>{children}</H6>
    </div>
  ),
  normal: ({ children }: PropsWithChildren) => (
    <p style={{ marginBottom: '1rem' }}>{children}</p>
  ),
};
